import { Component, OnInit, Inject } from "@angular/core";

import { SoundEnum } from "src/app/enums/sound.enum";
import { ICompany } from "src/app/interfaces/company";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { MarkManagementService } from "src/app/services/http/business/markManagement/mark-management.service";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-mark-type-entry',
  templateUrl: './mark-type-entry.component.html',
  styleUrls: ['./mark-type-entry.component.css']
})
export class MarkTypeEntryComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  cCode: string;
  errors = new Array();
  companyList: ICompany[];
  eduPackageList: IEducationPackage;

  constructor(
    private fb: FormBuilder,
    private eduPackageService: EducationPackageService,
     private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private markManagementService: MarkManagementService,
    private dialogRef: MatDialogRef<MarkTypeEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) {}

  ngOnInit() {
    this.getEduPackage();
    this.createForm();
  }

  createForm() {
   
    this.form = this.fb.group({
      MarkTypeTitle: [
        this.data.IsUpdate ? this.data.MarkTypeTitle.toString() : "",
        Validators.compose([Validators.required, Validators.maxLength(70)])
      ],
      PackageId: [
        this.data.IsUpdate ? this.data.PackageId : null,
        Validators.compose([Validators.required, Validators.maxLength(70)])
      ],
      
      IsActive: [
        this.data.IsUpdate? this.data.IsActive: true
      ],
      Coefficient: [
        this.data.IsUpdate ? this.data.Coefficient :0,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(10)
        ])
      ]
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit(form: any) {
   
    this.errors = new Array();
    let command={
      "PackageId": form.PackageId,
      "Id": this.data.IsUpdate?this.data.Id:0,
      "MarkTypeTitle": form.MarkTypeTitle,
      "MarkTypeCatId": this.data.MarkTypeCatId,
      "Coefficient": form.Coefficient,
      "IsActive": form.IsActive
    }
    if (this.data.IsUpdate == false) {
      this.markManagementService.add(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.markType", { name: this.translate.get('label.submit')}),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.onNoClick();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
    if (this.data.IsUpdate) {
      form.Id = this.data.Id;
      this.markManagementService.edit(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.markType", { name: this.translate.get('label.edit') }),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close(form);
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }
}
